// extracted by mini-css-extract-plugin
export default {"searchIcon":"TopNavSearch_searchIcon__F98xN","searchBar":"TopNavSearch_searchBar__wEDcq"};